// src/hooks/paxTypes/useForceDeletePaxType.js
import { useMutation, useQueryClient } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { forceDeletePaxType as forceDeletePaxTypeAPI } from "../../api/apiPaxTypes";
import parseError from "../../utils/parseError";

const useForceDeletePaxType = () => {
    const queryClient = useQueryClient();

    const { mutate: forceDeletePaxType, isPending: isForceDelete } = useMutation({
        mutationFn: forceDeletePaxTypeAPI,
        onSuccess: (res) => {
            const message = res?.message || "Pax type permanently deleted";
            toast.success(message);
            queryClient.invalidateQueries({ queryKey: ["paxTypes"] });
        },
        onError: (error) => {
            const msg = parseError(error);
            toast.error(msg || "Failed to permanently delete pax type");
        },
    });

    return { forceDeletePaxType, isForceDelete };
};

export default useForceDeletePaxType;